// extracted by mini-css-extract-plugin
export var locationCard = "_fa-0";